/* eslint-disable no-unused-vars */
import { useState } from 'react';
import ReactHowler from 'react-howler';
import {
  Box,
  Card, makeStyles, Typography,
} from '@material-ui/core';
import { Html } from '@react-three/drei';
import { Select } from '@react-three/postprocessing';
import PropTypes from 'prop-types';

import click from '../../../assets/audio/clickEffect.mp3';
import nubeHover from '../../../assets/img/nube_hover_world.png';

const useStyle = makeStyles((theme) => ({
  modal: {
    width: 150,
    background: theme.palette.background.secondary,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(1, 0),
  },
  modalText: {
    fontFamily: 'Raleway',
    fontSize: 15,
    marginBottom: theme.spacing(2),
    textAlign: 'center',
    padding: theme.spacing(2),
  },
  containerBox: {
    backgroundImage: `url(${nubeHover})`,
    backgroundRepeat: 'no-repeat',
    minWidth: 230,
    minHeight: 90,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));
function HoverBuilding({
  component, nameSede, status, idTopic, idUser, finalProject, actions, positionHtml, theme,
}) {
  const classes = useStyle();
  const [hover, setHover] = useState(null);
  const [play, setPlay] = useState(false);
  const handlePlay = () => {
    setPlay(true);
    const path = window.location.pathname;
    sessionStorage.setItem('sub', idUser);
    window.history.pushState({ state: true }, 'CanvasHome', '');
    window.location.replace(`${path}/theme/${nameSede}/${idTopic}`);
  };
  const handleHoverPointerOver = () => {
    setHover(true);
  };
  const handleHoverPointerLeave = () => {
    setPlay(false);
    setHover(false);
  };
  const printContent = () => {
    if (status === false && !finalProject) {
      return (
        <>
          <Html>
            <ReactHowler src={click} playing={play} />
          </Html>
          {hover
            ? (
              <Html position={positionHtml}>
                <Box className={classes.containerBox}>
                  <Typography className={classes.modalText}>{theme}</Typography>
                </Box>
                {/* <Card className={classes.modal} occlude elevation={0}>
                  <Typography className={classes.modalText}>{theme}</Typography>
                </Card> */}
              </Html>
            ) : null}
          <Select enabled>
            <mesh
              onPointerOver={handleHoverPointerOver}
              onPointerLeave={handleHoverPointerLeave}
              onClick={handlePlay}
            >
              {component}
            </mesh>
          </Select>
        </>
      );
    }
    if (finalProject) {
      return (
        <>
          <Html>
            <ReactHowler src={click} playing={play} />
          </Html>
          {hover
            ? (
              <Html position={positionHtml}>
                <Box className={classes.containerBox}>
                  <Typography className={classes.modalText}>{theme}</Typography>
                </Box>
                {/* <Card className={classes.modal} occlude elevation={0}>
                  <Typography className={classes.modalText}>{theme}</Typography>
                </Card> */}
              </Html>
            ) : null}
          <Select enabled={status}>
            <mesh
              onPointerOver={handleHoverPointerOver}
              onPointerLeave={handleHoverPointerLeave}
              onClick={status ? actions : null}
            >
              {component}
            </mesh>
          </Select>
        </>
      );
    }
    return (
      <>
        <Html>
          <ReactHowler src={click} playing={play} />
        </Html>
        {hover
          ? (
            <Html position={positionHtml}>
              {/* <Card className={classes.modal} occlude elevation={0}>
                <Typography className={classes.modalText}>{theme}</Typography>
              </Card> */}
              <Box className={classes.containerBox}>
                <Typography className={classes.modalText}>{theme}</Typography>
              </Box>
            </Html>
          ) : null}
        <Select enabled={hover}>
          <mesh
            onPointerOver={handleHoverPointerOver}
            onPointerLeave={handleHoverPointerLeave}
            onClick={handlePlay}
          >
            {component}
          </mesh>
        </Select>
      </>
    );
  };
  return <group>{printContent()}</group>;
}

export default HoverBuilding;

HoverBuilding.propTypes = {
  component: PropTypes.element.isRequired,
  nameSede: PropTypes.string.isRequired,
  idUser: PropTypes.string,
  status: PropTypes.bool,
  idTopic: PropTypes.string,
  finalProject: PropTypes.bool,
  actions: PropTypes.func,
  positionHtml: PropTypes.arrayOf(PropTypes.number),
  theme: PropTypes.string.isRequired,
};

HoverBuilding.defaultProps = {
  status: false,
  idUser: '',
  idTopic: null,
  finalProject: false,
  actions: null,
  positionHtml: null,
};
